import { useThemeContext } from '@huggg/react-components';
import { PrimaryButton } from '@huggg/react-components';
import classnames from 'classnames';
import {
  Huggg,
  LocationsDialog,
  RecipientDescription,
  Title,
} from 'components';
import { MessageBubble } from 'components/MessageBubble';
import { PageTitle } from 'components/misc';
import {
  Emoji as UIEmoji,
  PoweredByHuggg as UIPoweredByHuggg,
} from 'components/ui';
import { withHuggg, withRedirect } from 'hoc';
import { useAnalytics } from 'hooks';
import useDictionary from 'hooks/useDictionary';
import { Layout } from 'layouts';
import PropTypes from 'prop-types';
import { compose } from 'ramda';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { isSuperHuggg } from 'utilities/huggg';
import { getBrandName, getProductName } from 'utilities/huggg';
import { interpolateMany } from 'utilities/interpolate';
import styles from './stashed.module.scss';

export const ScreensStashedHuggg = (props) => {
  const dict = useDictionary();
  const { huggg, isFirstStashed, isRedeemable } = props;

  const { shouldShowPoweredByHuggg } = useThemeContext();

  const analytics = useAnalytics();
  const title = interpolateMany(dict.stashComplete.huggg.title, [
    [
      ':emoji_raising_hands:',
      <UIEmoji label="raising hands" symbol="🙌" key={null} />,
    ],
    ['[br]', <br key={null} />],
    ['[product_name]', <>{getProductName(huggg)}</>],
  ]);

  const message = isSuperHuggg(huggg) ? huggg.message : huggg.message.message;

  useEffect(() => {
    analytics.screenViewedHugggStashed();
  }, [analytics, huggg]);

  return (
    <Layout showBackButton={false}>
      <PageTitle huggg={huggg} />
      <div
        data-test-id="screen-stashed"
        className={classnames('container', styles.container)}
      >
        <Huggg showDetails={!isFirstStashed} huggg={huggg} />

        {shouldShowPoweredByHuggg && <UIPoweredByHuggg />}

        {!isFirstStashed && message && (
          <MessageBubble text={message} animate={false} />
        )}

        <Title>{title}</Title>

        {!isFirstStashed && <RecipientDescription huggg={huggg} />}

        {!isFirstStashed && isRedeemable && (
          <Link
            to={`/${huggg.shortcode}/redeem`}
            style={{ textDecoration: 'none' }}
          >
            <PrimaryButton
              className={styles.redeemButton}
              label={dict.redeemNowWithoutStashingButton}
            />
          </Link>
        )}
      </div>

      {!isFirstStashed && <LocationsDialog brandName={getBrandName(huggg)} />}
    </Layout>
  );
};

ScreensStashedHuggg.propTypes = {
  huggg: PropTypes.object.isRequired,
  isRedeemable: PropTypes.bool.isRequired,
  isStashed: PropTypes.bool,
  isRedeemed: PropTypes.bool,
  isFirstStashed: PropTypes.bool,
};

const notStashedRedirectHandler = (props) => [
  !props.isStashed,
  `/${props.huggg.shortcode}/stash`,
];

const redeemedRedirectHandler = (props) => [
  props.isRedeemed,
  `/${props.huggg.shortcode}/redeemed`,
];

export default compose(
  withHuggg,
  withRedirect(redeemedRedirectHandler),
  withRedirect(notStashedRedirectHandler),
)(ScreensStashedHuggg);
